/// <amd-module name="Feed/CreateFeed/Redux/ZeroFeeds/ZeroFeedsSelectors" />
import { IVssPageContext } from "VSS/Platform/Context";
import { getAssetLocation } from "VSS/Platform/Location";
import { UserClaims, userHasClaim } from "VSS/Platform/UserClaims";

import { IZeroFeedsState } from "./ZeroFeedsContracts";

export function getZeroFeedsData(pageContext: IVssPageContext): IZeroFeedsState {
    const isAnonymousUser = userHasClaim(pageContext, UserClaims.Anonymous);
    const isPublicUser = userHasClaim(pageContext, UserClaims.Public);
    const isUserAnonymousOrPublic: boolean = isAnonymousUser || isPublicUser;

    const imagePath: string = getAssetLocation(pageContext, "ms.feed/feed-createfeed/content/zerofeeds.svg");

    const data: IZeroFeedsState = {
        isUserAnonymousOrPublic,
        imagePath
    };

    return data;
}
